import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { DeploymentService } from '../../../../core/services/deployment.service';
import { Deployment } from '../../../../core/models/deployment';
import { NodeConfigService } from '../../../../core/services/node-config.service';
import { HpcConfig } from '../../../../core/models/node-config';

@Component({
  selector: 'app-update-cluster',
  templateUrl: './update-cluster.component.html',
  styleUrls: ['./update-cluster.component.scss']
})
export class UpdateClusterComponent implements OnInit {

  constructor(
    private deploymentService: DeploymentService,
    public dialogRef: MatDialogRef<UpdateClusterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { depName: string },
    private _spinner: NgxSpinnerService,
    private snackBar: MatSnackBar,
    public nodeConfigService: NodeConfigService,
  ) { }
  updateClusterForm: UntypedFormGroup;
  deployment: Deployment;
  numberOfStaticComputeNodes: number = 0;
  hpcConfig: string = null;
  nodeConfigNames: HpcConfig[] = [];
  cloudProvidersList: string[] = [];
  selectedHpcConfig: HpcConfig;
  noteMessage: string = "Note : Resizing node will cause it to reboot";

  ngOnInit(): void {
    this.getDeploymentDetails();
    this.updateClusterForm = new UntypedFormGroup({
      nodeSize: new UntypedFormControl(
        '',
        [Validators.required, Validators.pattern('^[A-Za-z0-9-_.@]+$')]
      ),
      numberOfStaticComputeNodes: new UntypedFormControl('', [Validators.required, Validators.pattern(/^[1-9][0-9]*$/)]),
      numberOfDynamicComputeNodes: new UntypedFormControl('', [Validators.required, Validators.pattern(/^[1-9][0-9]*$/)]),
    });
  }

  onSubmit(form) {
    this._spinner.show('updateCredential')
    try {
      if (form.status == 'INVALID') {
        this.updateClusterForm.markAllAsTouched();
        this._spinner.hide('updateCredential')
        this.snackBar.open("Please verify all form fields are entered and entered correctly", "Ok", { duration: 3000 });
        return;
      }

      let updateClusterValues: any = {
        nodeSize: form.value?.nodeSize,
        numberOfStaticComputeNodes: form.value?.numberOfStaticComputeNodes?.toString(),
        numberOfDynamicComputeNodes: form.value?.numberOfStaticComputeNodes?.toString()
      };

      this.deploymentService.updateCluster(
        this.data.depName,
        updateClusterValues,
      ).subscribe({
        next: (data: any) => {
          this._spinner.hide('updateCredential');
          this.dialogRef.close(data?.actionMessage);
        },
        error: (error: any) => {
          this._spinner.hide('updateCredential')
          this.dialogRef.close(error?.error?.actionMessage);
        }
      });
    }
    catch (e) { }
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  onClose() {
    this.dialogRef.close(false)
  }

  getDeploymentDetails() {
    this._spinner.show('updateCredential')
    this.deploymentService.getDeployment(this.data.depName).subscribe((data) => {
      if (!data) {
        this._spinner.hide('updateCredential')
        this.snackBar.open("Unable to fetch deployment details.", "Ok", { duration: 5000 });
        return;
      }
      this.deployment = <Deployment>JSON.parse(JSON.stringify(data));
      if (this.deployment) {
        this.numberOfStaticComputeNodes = this.deployment.numOfComputeNodes;
        this.updateClusterForm?.controls['numberOfStaticComputeNodes'].setValue(this.numberOfStaticComputeNodes)
        this.hpcConfig = '';
        this.loadNodeConfig()
      }
    });
  }

  loadNodeConfig() {
    this._spinner.show('updateCredential')
    this.nodeConfigService
      .getHpcConfigDetails(
        this.data.depName
      )
      .subscribe({
        next: (data) => {
          this.nodeConfigNames = JSON.parse(JSON.stringify(data));
          if (this.nodeConfigNames?.length == 0) {
            this.snackBar.open("No node configuration is available, please add first.", "OK", {
              duration: 5000
            })
            return;
          }
          else if (this.nodeConfigNames?.length == 1) {
            if (this.nodeConfigNames![0].instanceCode?.toLowerCase() == this.hpcConfig?.toLowerCase()) {
              this.snackBar.open("No node configuration is available other than current size of node, please add another first.", "OK", {
                duration: 5000
              })
              this.selectedHpcConfig = this.nodeConfigNames![0];
              return;
            }
          }
          else if (this.hpcConfig) {
            if (this.nodeConfigNames.some(obj => obj.instanceCode == this.hpcConfig)) {
              this.selectedHpcConfig = this.nodeConfigNames.find(obj => obj.instanceCode == this.hpcConfig);
              this.updateClusterForm?.controls['nodeSize'].setValue(this.selectedHpcConfig?.instanceCode)
            }
          }
          else {
            this.selectedHpcConfig = this.nodeConfigNames![0];
            this.updateClusterForm?.controls['nodeSize'].setValue(this.selectedHpcConfig?.instanceCode)
          }
          this._spinner.hide('updateCredential')
        },
        error: (err) => {
          this._spinner.hide('updateCredential')
          this.snackBar.open(err?.errorMessage, "OK", {
            duration: 5000
          })
        },
        complete: () => { }
      })
  }

  hpcConfigChanged(hpcConfigId) {
    this.selectedHpcConfig = this.nodeConfigNames?.find(nd => nd.hpcConfigId == hpcConfigId);
  }
}
